<template>
  <div class="box" style="width: 100%;" >
    <div class="reward-item">
      <h4 class="reward-item-text">Shopping Cart</h4>
      <div>
        <div v-for="item of carts" class="carts-item">
          {{item.GiftName}}
          <div class="carts-btn">
            <b-input type="number"
                     @input.native="updateCart(item, $event)"
                     :value="item.DesiredQuantity"
                     class="item-input" />

          </div>
        </div>
      </div>
      <p>Total: {{cartPoint |  numberFormat('', 0)}} Point</p>
      <p style="margin-bottom: 24px"
         v-show="cartNumber === 0">
        Please add reward to cart</p>

      <p style="margin-bottom: 24px"
         v-show="cartPoint > availablePoint">
        Has exceeded the point you have</p>

      <div class="check-out-box">

        <b-btn variant="primary"
               :disabled="cartNumber === 0 || cartPoint > availablePoint"
               @click="$root.$emit('bv::show::modal', 'rewardCheckOutModal')">
          Check Out</b-btn>

      </div>
    </div>

    <div class="reward-item">
      <H4 class="reward-item-text">Available Point</H4>
      <div class="check-out-box">
        <b-link @click="$root.$emit('bv::show::modal', 'rewardSummaryModal')">
          <h2 class="available-point">{{availablePoint | numberFormat('', 0)}}</h2>
          See detail</b-link>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    components: {
    },
    computed: {
      availablePoint () {
        return this.$store.state.reward.point.AvailablePoints
      },
      carts () {
        return this.$store.state.reward.carts
      },
      cartNumber () {
        return this.$store.getters['reward/cartNumber']
      },
      cartPoint () {
        return this.$store.getters['reward/cartPoint']
      }
    },
    methods: {
      addCart (item, qunatity) {
        item.quantity = qunatity || 1
        this.$store.commit('reward/updateCart', item)
      },
      updateCart (item, e) {
        let quantity = parseInt(e.target.value)
        if (isNaN(quantity)) {
          return false
        }
        item.Id = item.GiftId
        item.quantity = quantity
        item.isUpdated = true
        this.$store.commit('reward/updateCart', item)
      }
    }
  }
</script>
<style scoped lang="scss">
  .sub-title {
    color: $color-text-grey;
    font-size: $size-normal;
    font-weight: normal;
    margin-bottom: 1em;
  }
  .box {
    display: block
  }
  .reward-item {
    padding-bottom: 16px;
    margin-bottom: 32px;
    border-bottom: 1px solid $color-border;
  }
  .carts-item {
    margin-bottom: 16px;
  }
  .add-btn {
    margin-top: 32px;
  }
  .item-btn {
    display: inline-block;
    width: 32px;
    padding: 0;
  }
  .item-input {
    display: inline-block;
    width: 72px;
    height: 25px;
  }
  .check-out-box {
    text-align: center;
  }

  .available-point {
    font-size: 24px;
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/reward/MRewardSlide.vue